import { jsxs, jsx } from 'react/jsx-runtime';
import { cn } from '../../lib/utils.js';

const ErrorCard = ({ label, icon, children, iconClass }) => {
  const titleBreak = typeof label === "string" ? label.replace(/<br\s*\/?>/gi, "\n") : label;
  return /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
    /* @__PURE__ */ jsx(
      "span",
      {
        className: cn(
          "flex items-center justify-center w-[64px] h-[64px] mx-auto",
          iconClass
        ),
        children: icon
      }
    ),
    /* @__PURE__ */ jsx("p", { className: "heading-h3-title mt-2 whitespace-pre-line text-center", children: titleBreak }),
    /* @__PURE__ */ jsx("p", { className: "body-lg font-weight-regular text-primary-02 mt-3 text-center", children })
  ] });
};

export { ErrorCard };
